import React from "react";
import jwt from 'jwt-decode'
import { ACCESS_TOKEN } from '../../settings/shared/constants';
import logo from "assets/img/df_logo.png";
import LoadingOverlay from 'react-loading-overlay';
import BarLoader from "react-spinners/BarLoader";


// reactstrap components
import {
  Container,
  Col
} from "reactstrap";

// core components
import "../../assets/css/custom.css";

const styles = {
    footer: {
      display: 'none'
    },
    backheight:{
      minHeight:'800px'
    }
}

class Loading extends React.Component {
  constructor(props) {
    super(props);
    let subDomain = window.location.hostname.split('.');  
      this.state = {
      checked:false,
      loading:true,
      subdomain:subDomain[0],
    };
  }

componentDidMount() {
  this.setState({subdomain:'subDomain[0]'})
  document.body.classList.add("login-page");
  
    document.body.classList.add("bgdefault");
    document.body.style.backgroundColor = '#fff';


      if(localStorage.getItem(ACCESS_TOKEN) != null){
        // this.loadCurrentlyLoggedInUser();
        //  this.props.history.push("/admin/dashboard");
      }
   }

  render() {    
  
    return (
      <>
        <div className="content loadingwhite" style={styles.backheight}>
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={5} className="ml-auto mr-auto">
                  <div className="text-center">
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                      <br></br>
                
                  <img src={logo} alt="decisionforce" className="text-center" style={{width:'100px', height:'100px'}}></img> 
                  </div>
                  <br></br>
                        <h5 className="text-center loadingtxt">Loading Decision Force...</h5>
                        <br></br>
                        <LoadingOverlay
      active={this.state.loading}
      spinner={<BarLoader
        height={5}
        width={200}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
      </LoadingOverlay>
                  
              </Col>
            </Container>
          </div>
        </div>
      </>
    );
  }
}

export default Loading;
